/* template */
<template><mpx-view :class="(isChecked && 'checked')" @tap.stop="toggleCheck" class="checkbox"><div :class="(isChecked && 'checked')" class="checkbox-inner"></div></mpx-view></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m236f9558"}'>
.checkbox
  width 18px
  height 18px
  position relative
  border-radius 6px
  background #FFFFFF
  border 1px solid #D4D3D3
  box-sizing border-box
  cursor pointer
  transition border 0.3s ease
  -webkit-tap-highlight-color transparent
  -moz-tap-highlight-color transparent
  overflow hidden
  &.checked
    background-color #FF6400
    border none
  &-inner
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%) scale(0)
    background-image url('https://ut-static.udache.com/webx/sfc/umPNV4UERO7bfybj8SSpI.png')
    background-size cover
    width 8.5px
    height 6px
    transition transform 0.3s ease
    &.checked
      transform translate(-50%, -50%) scale(1)
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m236f9558"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./checkbox.mpx.js?isComponent&outputPath=components%2Fcheckbox236f9558%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./checkbox.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fcheckbox236f9558%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m236f9558"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/checkbox236f9558/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
